/* eslint-disable no-bitwise */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { Router } from '@angular/router';
import { AlertController, MenuController, NavController, Platform } from '@ionic/angular';
import { DataService } from '../data.service';
import { Device } from './device';
import { Keyboard } from '@capacitor/keyboard';
import { Photo } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';
import { BleClient } from '@capacitor-community/bluetooth-le';
import { BleHelper } from './bleHelper';
import { Datapackage } from './datapackage';
import { User } from './user';
import { Batteryguard } from './batteryguard';


export class Base {

  static logdata: string[] = []

  static extDataService: DataService
  user: User
  _page = "Base"
  _whoAmI = "Base_not_set"

  offlinehint: string = ""
  datapackage: Datapackage = new Datapackage()
  initial: string = '0'
  static DUMMY_PIC_URL: string = "./assets/takephoto.png"
  static NO_PIC_URL: string = "./assets/noimage.png"

  public static log(data) {
    console.log(data)

    if (Array.isArray(data)) {

      data.forEach((element) => {

        if (Array.isArray(element)) {

          element.forEach((inner) => {

            if (inner !== null && inner !== undefined && inner.length > 200) {
              Base.logdata.push(">array>: " + inner.substring(0, 200) + " ...")
            } else {
              Base.logdata.push(">array>: " + inner.toString())
            }

          })

        } else {

          if (element !== null && element !== undefined && element.length > 200) {
            Base.logdata.push(">array>: " + element.substring(0, 200) + " ...")
          } else {

            if (Array.isArray(element)) {

              element.forEach((inner2) => {

                if (inner2 !== null && inner2 !== undefined && inner2.length > 200) {
                  Base.logdata.push(">array>: " + inner2.substring(0, 200) + " ...")
                } else {
                  Base.logdata.push(">array>: " + inner2.toString())
                }

              })

            } else {
              Base.logdata.push(">array>: " + element.toString())

            }
          }
        }

      })

    } else {

      if (data !== null && data !== undefined && data.length > 200) {
        Base.logdata.push((new Date()).valueOf() + ": " + data.substring(0, 200) + " ...")
      } else {
        Base.logdata.push((new Date()).valueOf() + ": " + data)
      }
    }
  }


  getWifiState(deviceId: string) {
    this.dataService.get(deviceId).then((wifiState) => {
      return wifiState;
    })
  }

  setWifiState(deviceId: string, state: string) {
    this.dataService.set(deviceId, state).then((wifiState) => {
      return wifiState;
    })
  }

  static navigationstack: string[] = []

  // Offlinesupport
  static OFFLINE: boolean = false



  //versionnumber: string
  //staging: string
  debug = false

  static TEMP_CAR_ID = "tempcarid"

  static sRouter: Router

  // indicates the onboarding state
  static initial: string = '0'

  // eslint-disable-next-line max-len
  constructor(public platform: Platform, public dataService: DataService, public router: Router, public navController: NavController, public alertController: AlertController, public menu: MenuController) {
    //Base.console('info', 'constructing Base')
    Base.extDataService = dataService
    Base.sRouter = router

    if (this.dataService !== undefined) {
      this.dataService.get('initial').then((initial) => {
        //// //Base.log('[' + this._page + '] initial from Base: ' + initial)
        Base.initial = initial
      })
    }

    this.showBackLinks()
  }



  updateOffline(mode) {
    if (mode === true) {
      this.offlinehint = "border-top: 5px red double;"
    } else {
      this.offlinehint = ""
    }

    Base.log("[" + this._page + "] offline@list: " + mode)
    if (this.datapackage !== undefined && this.datapackage !== null) {
      this.datapackage.offline = mode
    }

  }

  static dumpNavStack() {
    let level=0
    Base.navigationstack.forEach((nav)=>{
      console.log(level++ + " " + nav)
    })
  }

  static nav_pop() {

    Base.log("[Base] nav_pop")
    Base.navigationstack.splice(Base.navigationstack.length - 1, 1);
    Base.log(Base.navigationstack)
    //console.log(Base.navigationstack[Base.navigationstack.length-1])
    const target = Base.navigationstack[Base.navigationstack.length - 1]

    Base.dumpNavStack()

    if (Base.navigationstack.length === 0) {
      Base.log("######>> NAV_STACK_RESET<<######")
      return "list"

    } else {
      return target
    }
  }


  static nav_push(_page) {
    Base.log("[Base] nav_push " + _page + " to NAV")

    if (!Base.navigationstack.includes(_page) ) {
      console.log("[Base] nav_push " + _page + " to NAV")
      Base.navigationstack.push(_page) 
    }

    Base.dumpNavStack()

  }


  switchInitial(value) {

    this.dataService.getUser().then((user) => {
      Base.log(user)

      this.dataService.get('datapackage' + user.email).then((dp) => {
        dp.initial = value
        this.dataService.set('datapackage' + user.email, dp)
        this.dataService.set('initial', value).then((_) => {
          return value
        })
      })
    })
  }

  showBackLinks() {
    /*
        if (this.dataService!==null && this.dataService!=undefined) {

        this.dataService.get('initial').then((initial) => {
          this.dataService.get('devicelist_back').then((devicelist_back) => {
            this.dataService.get('photo').then((photo) => {
              this.dataService.get('add-car-back').then((addcarback) => {
                this.dataService.get('loggedin').then((loggedin) => {
                  this.dataService.get('assistant_back').then((assistant_back) => {
                    this.dataService.get('user').then((user) => {
                      this.dataService.get('device').then((device) => {

                        let backlinks = ('---------------------------')
                        backlinks += ('\n- initial: ' + initial)
                        backlinks += ('\n- assistant_back: ' + assistant_back)
                        backlinks += ('\n- devicelist_back: ' + devicelist_back)
                        backlinks += ('\n- add-car-back: ' + addcarback)
                        if (photo!==null) {
                          backlinks += ('\n- photo: ' + photo.length)
                        } else {
                          backlinks += ('\n- photo: no')
                        }
                        backlinks += ('\n- user: ')
                        backlinks += JSON.stringify(user)
                        backlinks += ('\n- device: ')
                        backlinks += JSON.stringify(device)
                        backlinks += ('\n- loggedin: ')
                        backlinks += JSON.stringify(loggedin)
                        backlinks += ('\n---------------------------')
                        //console.log(backlinks)
                      })
                    })
                  })
                })
              })
            })
          })
        })

      }
      */

  }

  showBackLinksAlert() {
    /*
        if (environment.envname === 'stage') {


          this.dataService.get('initial').then((initial) => {
            this.dataService.get('devicelist_back').then((devicelist_back) => {
              this.dataService.get('photo').then((photo) => {
                this.dataService.get('add-car-back').then((addcarback) => {
                  this.dataService.get('loggedin').then((loggedin) => {
                    this.dataService.get('assistant_back').then((assistant_back) => {

                      let backlinks = ('---------------------------')
                      backlinks += ('- initial: ' + initial)
                      backlinks += ('- assistant_back: ' + assistant_back)
                      backlinks += ('- devicelist_back: ' + devicelist_back)
                      backlinks += ('- add-car-back: ' + addcarback)
                      if (photo!==null) {
                          backlinks += ('\n- photo: ' + photo.length)
                        } else {
                          backlinks += ('\n- photo: no')
                        }
                      backlinks += ('- loggedin: ')
                      backlinks += JSON.stringify(loggedin)
                      backlinks += ('---------------------------')
                      // //console.log(backlinks)

                      backlinks = ('------------------')
                      backlinks += ('<br/>- initial: ' + initial)
                      backlinks += ('<br/>- assistant_back: ' + assistant_back)
                      backlinks += ('<br/>- devicelist_back: ' + devicelist_back)
                      backlinks += ('<br/>- add-car-back: ' + addcarback)
                      if (photo!==null) {
                          backlinks += ('\n- photo: ' + photo.length + '<br/>')
                        } else {
                          backlinks += ('\n- photo: no' + '<br/>')
                        }
                      backlinks += ('<br/>- loggedin: <br/>')
                      backlinks += JSON.stringify(loggedin)
                      backlinks += ('<br/>---------------------------')
                      this.presentAlert('- Backlinks -', '', backlinks)
                    })
                  })
                })
              })
            })
          })
        }
      */
  }

  toMain() {
    this.dataService.get('initial').then((initial) => {
      if (initial !== null && initial !== undefined && initial === '1') {
        this.navController.navigateForward('/assistant', { animated: false })
      } else {
        this.navController.navigateForward('/list', { animated: false })
      }
    })
  }
  /*
    static navigateForward(target) {
      Base.sRouter.navigate('/' + target)
    }
  */
  static console(level: string, text: any, context?: any, methodname?: any) {

    if (methodname === undefined) {
      methodname = ''
    } else {
      methodname = methodname + ': '
    }

    const show = ['info', 'method', 'error', 'device']
    if (context !== undefined) {
      ////// //console.log(context)
    }
    if (level === 'verbose') {
      if (show.includes(level)) {
        //// //console.log(level + ': ' + methodname + text)
      }
    }

    if (level === 'method') {
      if (show.includes(level)) {
        //// //console.log(level + ': ' + methodname + text)
      }
    }

    if (level === 'info') {
      if (show.includes(level)) {
        if (typeof (text) === 'object') {
          //// //console.log(level + ' (object): v ')
          //// //console.log(text)
        } else {
          //// //console.log(level + ': ' + methodname + text)
        }
      }
    }

    if (level === 'debug') {
      if (show.includes(level)) {
        if (typeof (text) === 'object') {
          //// //console.log(level + ' (object): v ')
          //// //console.log(text)
        } else {
          //// //console.log(level + ': ' + methodname + text)
        }
      }
    }

    if (level === 'error') {
      if (show.includes(level)) {
        if (typeof (text) === 'object') {
          //// //console.log(level + ' (object): v ')
          //// //console.log(text)
        } else {
          //// //console.log(level + ': ' + methodname + text)
        }
      }
    }

    if (level === 'device') {
      if (show.includes(level)) {
        if (typeof (text) === 'object') {
          //// //console.log(level + ' (object): v ')
          //// //console.log(text)
        } else {
          //// //console.log(level + ': ' + methodname + text)
        }
      }
    }

  }


  public static async getConnectedDevices() {
    //// //Base.log('[' + this._page + '] ----------------------------------------------------------')
    //// //Base.log('[' + this._page + '] ---------------vvvvvvvvvvvvvvvvvvvvvvvvvv-----------------')
    await BleClient.initialize({ androidNeverForLocation: true });

    //await BleClient.connect(this.currentDevice.deviceId);
    await BleClient.getConnectedDevices(
      [BleHelper.BATTERY_SERVICE, BleHelper.WIFI_SERVICE]
    ).then((connectedDevice) => {
      //// //Base.log('[' + this._page + '] devices')
      //// //console.log(connectedDevice)

      connectedDevice.forEach(element => {
        //// //Base.log('[' + this._page + '] element')
        //// //console.log(element)
      });
    });
    //// //Base.log('[' + this._page + '] --------------^^^^^^^^^^^^^^^^^^^^^^^^^^^^^---------------')
    //// //Base.log('[' + this._page + '] ----------------------------------------------------------')
  }

  static async sendData(deviceId, service, characteristic, message) {
    // //Base.log('[' + this._page + '] |--------SEND DATA -------------------|')
    // //Base.log('[' + this._page + '] - write')
    // //console.log(message)
    await BleClient.write(deviceId, service, characteristic, message)
    // //Base.log('[' + this._page + '] - read')
    const returner = await BleClient.read(deviceId, service, characteristic)
    // //console.log(returner)
    // //Base.log('[' + this._page + '] |---------------------------|')
    return returner
  }


  async presentAlertSuccess(title, sub, msg) {

    const alert = await this.alertController.create({
      cssClass: 'basic-alert-success',
      header: title,
      subHeader: sub,
      message: msg,
      buttons: ['OK']
    });
    Base.log("[" + this._page + "] PRESENT ALERT SUCCESS: " + title + " " + sub + " " + msg)
    await alert.present();
  }

  async presentAlert(title, sub, msg) {

    const alert = await this.alertController.create({
      cssClass: 'basic-alert',
      header: title,
      subHeader: sub,
      message: msg,
      buttons: ['OK']
    });
    Base.log("[" + this._page + "] PRESENT ALERT: " + title + " " + sub + " " + msg)
    await alert.present();
  }





  async presentAlert1(title, sub, msg) {
    let savetitle = ""
    //savetitle = this.translate.get('cancel')
    const alert = await this.alertController.create({
      header: title,
      buttons: [
        {
          text: savetitle,
          role: 'cancel',
          handler: () => {
            //this.handlerMessage = 'Alert canceled';
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            //this.handlerMessage = 'Alert confirmed';
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    //this.roleMessage = `Dismissed with role: ${role}`;
  }



  isDevice(): boolean {

    return true
    let veto = false

    //Base.console('info', '--=====Check platforms======--')
    const mobiles = []
    mobiles.push('android')
    mobiles.push('ios')
    mobiles.push('ipad')

    //["android", 'ios', 'ipad', 'iphone', 'mobile', 'phablet', 'pwa', 'tablet']
    mobiles.forEach((platform) => {
      //Base.console('info', platform + ' > ' + this.platform.is(platform))
      if (this.platform.is(platform)) {
        console.log(platform + ' > ' + this.platform.is(platform))
        veto = true
      }
    })
    Base.log('[' + this._page + '] --===== is mobile: ' + veto + ' ======--')
    return veto
  }



  public hideKeyboard() {
    Keyboard.hide()
    //Base.console('info', 'Enter pressed')
  }

  public toHelpPage() {
    //Base.console('info', '', this, 'Base navigateTo hilfe')
    this.navController.navigateForward('/hilfe', { animated: false })
  }



  restartOnboard() {
    //// //Base.log('[' + this._page + '] RESTART')
    this.dataService.del('deviceregistered')
    this.dataService.del('carcreated')
    this.dataService.del('wifiSetup')
    this.dataService.del('photo')

  }



  public toAssignCarPage() {
    //Base.console('info', '', this, 'Base navigateTo assigncar')
    this.navController.navigateForward('/assigncar', { animated: false })
  }


  public toDevicePage() {
    //Base.console('info', '', this, 'Base navigateTo device')
    this.navController.navigateForward('/device', { animated: false })
  }

  /*
    public toListPage() {
      //Base.console('info', '', this, 'Base navigateTo list')
      this.navController.navigateForward(['/list'])
    }


    */

  public fillDP(user, userImage, datapackage): Promise<Datapackage> {

    //const datapackage = new Datapackage()
    datapackage.origin = 'list'
    datapackage.context = 'user'
    datapackage.currentId = user.id

    return this.dataService.set('datapackage' + user.email, datapackage).then((_) => {
      return _
    })

  }

  public toUserPage(user, userImage, datapackage) {

    this.fillDP(user, userImage, datapackage).then((_) => {
      this.navController.navigateForward('/user', { animated: false })
    })
  }

  public toLoginPage() {
    //Base.console('info', '', this, 'Base navigateTo login')
    this.navController.navigateForward('/login', { animated: false })
  }

  public register() {
    //Base.console('info', '', this, 'Base navigateTo login')
    this.navController.navigateForward('/login', { animated: false })
  }

  public forgot() {
    //Base.console('info', '', this, 'Base navigateTo forgot')
    this.navController.navigateForward('/forgot', { animated: false })
  }

  public cancel() {
    //Base.console('info', '', this, 'Base navigateTo login')
    this.navController.navigateForward('/login', { animated: false })
  }

  public back() {
    Base.log("[" + this._page + "]back() **************BACK***************")
    console.log(Base.navigationstack)
    const backTo = Base.nav_pop()
    Base.log("[" + this._page + "]back() Going back to " + backTo)
    Base.log("[" + this._page + "]back() ***********************************************")

    this.navController.navigateForward('/' + backTo, { animated: false })
  }


  public backToMenu() {
    //Base.log("[" + this._page + "] **************NEW BACK OVER STACK***************")
    console.log(Base.navigationstack)
    const backTo = Base.nav_pop()
    Base.log("[" + this._page + "] Going back to " + backTo)
    //Base.log("[" + this._page + "] ***********************************************")
    this.menu.open('end');
    this.navController.navigateForward('/' + backTo, { animated: false })
  }






  restartSystem() {
    //// //Base.log('[' + this._page + '] RESTART')
    this.dataService.del('deviceregistered')
    this.dataService.del('carcreated')
    this.dataService.del('wifiSetup')
    this.dataService.del('photo')

  }

  toLogin() {
    //Base.console('info', 'Moving forward to Login')
    this.dataService.set('initial', '0')
    //Base.console('info', '', this, 'Base navigateTo login')
    this.navController.navigateForward('/login', { animated: false });
  }

  toRegister() {
    //Base.console('info', 'Moving forward to Register')
    this.dataService.set('initial', '1')
    this.dataService.set('notSetup', '1') // Hier geht es immer zurück zum Onboarding

    this.dataService.del('continue')
    this.dataService.del('origin_carcreate')

    //Base.console('info', '', this, 'Base navigateTo register')
    this.navController.navigateForward('/register', { animated: false });
  }



  toOnboard() {
    //Base.console('info', 'Moving forward to Onboarding')
    Base.log('Preview navigateTo onboard (Base)')
    this.navController.navigateForward('/onboard', { animated: false });
  }

  toConfirmPage() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo onboard')
    this.navController.navigateForward('/confirm', { animated: false });
  }

  toPhotoPage() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo onboard')
    this.navController.navigateForward('/photo', { animated: false });
  }

  toPreviewPage() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo onboard')
    this.navController.navigateForward('/preview', { animated: false });
  }

  toPreview() {
    //Base.console('info', 'Moving forward to Preview')
    //Base.console('info', '', this, 'Base navigateTo Preview')
    this.navController.navigateForward('/preview', { animated: false });
  }

  toOnboardHelp(topic: string) {
    //Base.console('info', 'Moving forward to Onboarding')
    this.dataService.set('helpcontext', topic)
    //Base.console('info', '', this, 'Base navigateTo hilfe')
    this.navController.navigateForward('/hilfe', { animated: false });
  }

  toBluetoothHelp() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo hilfe')
    this.navController.navigateForward('/hilfe', { animated: false });
  }

  toWifiHelp() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo hilfe')
    this.navController.navigateForward('/hilfe', { animated: false });
  }

  toRegisterDevice2(offline: boolean) {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo registerdevice')
    if (offline === false) {
      this.navController.navigateForward('/registerdevice', { animated: false });
    }
  }

  toAssignToCar() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo device')
    this.navController.navigateForward('/device', { animated: false });
  }

  toWifiSetup() {
    //Base.console('info', 'Moving forward to Onboarding')
    //Base.console('info', '', this, 'Base navigateTo hilfe')
    this.navController.navigateForward('/hilfe', { animated: false });
  }

  /**
  * Call add-car-page for plain new vehicle
  */
  public toNewCarPage() {

    const datapackage = new Datapackage()
    datapackage.origin = 'list'
    datapackage.data = ''
    datapackage.data = Base.DUMMY_PIC_URL

    datapackage.context = 'car'
    datapackage.currentId = "temp"
    this.dataService.getUser().then((user) => {
      this.dataService.set('datapackage' + user.email, datapackage).then(() => {
        this.navController.navigateForward('/add-car', { animated: false })
      })
    })
    /*
    this.dataService.set('add-car-back', 'list').then(() => {
      this.dataService.set('createcar', '1').then(() => {
        this.dataService.del('deviceid').then(() => {
          this.dataService.del('tempcarimage').then(() => {
            this.dataService.set('currentcar', 'tempcar').then(() => {
            this.navController.navigateForward(['/add-car'])
          })
        })
      })
      })
    })
    */
  }



  /*async connect(deviceid) {


    //this.showLiveData('hbg_' + deviceid)
    this.getInfoFast(deviceid)

  }*/

  //async getInfoFast(deviceLabel):Promise<Batteryguard> {
  public async toWifiPage(dev: Device, datapackage: Datapackage) {

    Base.log("[" + this._page + "] toWifiPage: " + "hbg_" + dev.id)
    Base.log(dev)

    this.dataService.get('user').then((user) => {
      this.dataService.set('datapackage' + user.email, datapackage).then(() => {
        this.navController.navigateForward('/wifi', { animated: false })
      })
    })

    /*

    BleClient.requestLEScan(
      { name: "hbg_" + dev.id },
      (result) => {
        //this.connectToBTDeviceForConfiguration(label, result['device']['deviceId'], configValue, targetByte)

        const deviceId = result['device']['deviceId']
        Base.log('[' + this._page + '] * Connect to ' + deviceId)

        let anzahlWifis = 0

        return BleClient.connect(deviceId).then((result) => {

          Base.log('[' + this._page + '] * Connected to ' + deviceId)

          let bg = new Batteryguard()
          //Base.console('info', '---trying BATTERY_SENSOR_CHARACTERISTIC ---');
          return BleClient.read(deviceId, BleHelper.BATTERY_SERVICE, BleHelper.GENERAL_CHARACTERISTIC).then((r: DataView) => {

            bg.serialNo = ('' + r.getUint8(0) + '.' + r.getUint8(1) + '.' + r.getUint8(2))

            bg.firmware = '' + r.getUint8(4) + '.' + r.getUint8(5) + '.' + r.getUint8(6)

            //Base.console('info', r.getUint8(7))
            bg.lastError = '' + r.getUint8(7)

            //Base.console('info', r.getUint16(8))
            bg.errorline = '' + r.getUint16(8)

            //Base.console('info', r.getUint8(10))
            bg.registration = '' + r.getUint8(10)

            //Base.console('info', r.getUint16(11))
            bg.wifi = '' + r.getUint8(11)
            anzahlWifis = r.getUint8(11)
            //this.dataService.setWifi(this.devicename, bg.wifi)
            //this.persistCntWifis(this.devicename, +bg.wifi)

            //Base.console('info', r.getUint8(17))
            bg.cntWifis = '' + r.getUint8(17)

            //Base.console('info', r.getUint8(19))
            bg.interval = r.getUint8(19)

            //Base.log("[" + this._page + "] 1 write interval" + this.devicename + " to " + bg.interval)
            //this.persistInterval(this.car.installedDeviceId, bg.interval)

            Base.log('[' + this._page + '] DeviceInfos')
            Base.log(bg)
            //this.showWipeSpinner = false




            Base.log("[" + this._page + "] ---------------------------------------")
            console.log(bg)
            Base.log("[" + this._page + "] ---------------------------------------")

            let title = "Gerät " + bg.serialNo + " wurde ausgelesen."
            if (anzahlWifis > 0) {
              title += anzahlWifis + " WLANs ermittelt."
            } else {
              title += "Keine WLANs ermittelt."
            }

            BleClient.stopLEScan().then((_) => {
              BleClient.stopNotifications(deviceId, BleHelper.BATTERY_SERVICE, BleHelper.SENSOR_CHARACTERISTIC).then((_) => {
                setTimeout(async () => {
                  BleClient.disconnect(deviceId).then((result) => {

                    this.dataService.stopScanning().then((_) => { })
                  });
                }, 1);
              })
            })

            const alert = this.alertController.create({
              cssClass: 'basic-alert',
              //header: userimage,
              subHeader: '',
              message: title,
              buttons: [{
                text: "Weiter", handler: () => {
                  datapackage.origin = 'assistant'
                  datapackage.photoboxContinue = 'add-car'
                  datapackage.context = 'dev'
                  datapackage.currentId = dev.id
                  datapackage.device = dev

                  Base.log("[" + this._page + "] toAssistantPage")
                  console.log(datapackage)

                  this.dataService.get('user').then((user) => {
                    this.dataService.set('datapackage' + user.email, datapackage).then(() => {
                      this.navController.navigateForward('/wifi', { animated: false })
                    })
                  })
                }
              }, {
                text: "Abbrechen", handler: () => {
                  return
                }
              }]
            }).then((_) => {
              _.present()
            })

          })
        })
      })
    return
    */
  }

  /*
    public async toWifiPage(dev: Device, datapackage: Datapackage) {
      //Base.console('info', '', this, 'Base navigateTo wifi')

      //alert("Gerät wird ausgelesen")
      this.getInfoFast(dev.label).then((bg) => {
        Base.log("[" + this._page + "] ---------------------------------------")
        console.log(bg)
        Base.log("[" + this._page + "] ---------------------------------------")

        const alert = this.alertController.create({
          cssClass: 'basic-alert',
          //header: userimage,
          subHeader: '',
          message: "Gerät wird ausgelesen " + bg.serialNo,
          buttons: [{
            text: "Weiter", handler: () => {
              datapackage.origin = 'assistant'
              datapackage.photoboxContinue = 'add-car'
              datapackage.context = 'dev'
              datapackage.currentId = dev.id
              datapackage.device = dev

              Base.log("[" + this._page + "] toAssistantPage")
              console.log(datapackage)

              this.dataService.get('user').then((user) => {
                this.dataService.set('datapackage' + user.email, datapackage).then(() => {
                  this.navController.navigateForward('/wifi', { animated: false })
                })
              })
            }
          }, {
            text: "galery", handler: () => {
              return
            }
          }]
        }).then((_)=>{
          _.present()
        })


      })





    }
  */


  /**
    * Call details-page for existing vehicle
    */
  toEditCarPage(car, datapackage) {

    datapackage.origin = 'add-car'
    datapackage.photoboxContinue = 'add-car'
    datapackage.context = 'car'
    datapackage.currentId = car.id
    datapackage.data = car.image
    datapackage.car = car
    datapackage.workflow = "editcar"

    Base.log("[" + this._page + "] toEditCarPage")
    Base.log(datapackage)
    this.dataService.get('user').then((user) => {
      this.dataService.set('datapackage' + user.email, datapackage).then(() => {
        this.navController.navigateForward('/add-car', { animated: false })
      })
    })

  }


  /**
  * Call details-page for existing vehicle
  */
  toDetailsPage(car, datapackage) {

    datapackage.origin = 'details'
    datapackage.photoboxContinue = 'add-car'
    datapackage.context = 'car'
    datapackage.currentId = car.id
    datapackage.data = car.image
    datapackage.car = car
    datapackage.car.voltageThresholds = car.voltageThresholds
    datapackage.car.currentThresholds = car.currentThresholds

    Base.log("[" + this._page + "] toDetailsPage")
    Base.log(datapackage)
    this.dataService.get('user').then((user) => {
      this.dataService.set('datapackage' + user.email, datapackage).then(() => {
        this.navController.navigateForward('/details', { animated: false })
      })
    })

  }

  /**
  *
  * @param dev
  */
  public toEditDeviceByName(devicename: string, datapackage: Datapackage) {

    let dev: Device

    this.datapackage.devices.forEach((device) => {
      if (device.id === devicename) {
        dev = device
      }
    })
    datapackage.origin = 'devicelist'
    datapackage.photoboxContinue = 'add-car'
    datapackage.context = 'car'
    datapackage.currentId = dev.id
    datapackage.device = dev

    Base.log("[" + this._page + "] toAssistantPage")
    console.log(datapackage)
    this.dataService.get('user').then((user) => {
      this.dataService.set('datapackage' + user.email, datapackage).then(() => {
        this.navController.navigateForward('/assistant', { animated: false })
      })
    })

  }

  /**
 *
 * @param dev
 */
  public toEditDevice(dev: Device, datapackage: Datapackage) {

    this.datapackage.devices.forEach((device) => {
      if (device.id === dev.id) {
        dev = device
      }
    })
    datapackage.origin = 'devicelist'
    datapackage.photoboxContinue = 'add-car'
    datapackage.context = 'car'
    datapackage.currentId = dev.id
    datapackage.device = dev

    Base.log("[" + this._page + "] toAssistantPage")
    console.log(datapackage)
    this.dataService.get('user').then((user) => {
      this.dataService.set('assistantBack', "devicelist").then(() => {
        this.dataService.set('datapackage' + user.email, datapackage).then(() => {
          this.navController.navigateForward('/assistant', { animated: false })
        })
      })
    })

  }

  /*
public toEditDevice(dev: Device) {
  this.stopScan()
  this.datapackage.device = dev
  this.dataService.set('datapackage' + this.user.id, this.datapackage).then((_) => {
    this.dataService.set('deviceid', dev.id).then((_) => {
      // //console.log(dev)
      this.dataService.set('assistant_back', 'details').then((_) => {
        this.toDevicePage()
      })
    })
  })
}
*/

  public toAssistant(dev: Device) {

    // this.stopScan()
    //Base.log("[" + this._page + "] dev")
    //console.log(dev)
    this.datapackage.device = dev

    this.dataService.set('device', dev).then((_) => {
      this.dataService.set('datapackage' + this.user.email, this.datapackage).then((___) => {
        this.navController.navigateForward('/assistant', { animated: false });
      })
    })

  }


  /*
  * Imagehandling
  */

  // Helper function
  convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  async readAsBase64(photo: Photo) {
    if (this.platform.is('hybrid')) {
      const file = await Filesystem.readFile({
        path: photo.path
      });

      return file.data;
    }
    else {
      // Fetch the photo, read as a blob, then convert to base64 format
      const response = await fetch(photo.webPath);
      const blob = await response.blob();

      return await this.convertBlobToBase64(blob) as string;
    }
  }


  public toUTF8Array(str) {
    const utf8 = [];
    for (let i = 0; i < str.length; i++) {
      let charcode = str.charCodeAt(i);
      if (charcode < 0x80) { utf8.push(charcode) }
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6),
          0x80 | (charcode & 0x3f));
      }
      else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + (((charcode & 0x3ff) << 10)
          | (str.charCodeAt(i) & 0x3ff));
        utf8.push(0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
    }
    return utf8;
  }

  /**
   * Is bluetooth enabled on device?
   */
  async isBluetoothEnabled() {
    try {
      await BleClient.initialize({ androidNeverForLocation: true });
      const isBtEnabled = await BleClient.isEnabled();
      if (!isBtEnabled) {
        //// //Base.log('[' + this._page + '] BT failed')
      } else {
        //// //Base.log('[' + this._page + '] BT ok')
      }
    } catch (e) {
      //// //console.log(e);
    }
  }


  /**
   * Bluetooth lifecycle
   * @param deviceId
   */
  onDisconnect(deviceId: string): void {
    //// //console.log(`device ${deviceId} disconnected`);
  }

}
